import React from 'react';

import { InputComponent } from "../../reusable/simpleComponents/index";
import './styles.css';

interface Props {
    type: string,
    name: string,
    label: string,
    id: string,
    autoFocus?: () => void,
    refCustom: React.RefObject<HTMLInputElement>,
    title: string,
    disabled: boolean,
    readonly: boolean
}

const AuthInputComponent: React.FC<Props> = (props) => {
    return (
        <div className='auth-label-container'>
            <div className='auth-label-wrapper'>
                <label htmlFor={props.id}>{props.label}</label>
            </div>
            <InputComponent
                class='auth-input'
                {...props}
            />
        </div>
    )
};

export default AuthInputComponent
